<template>
  <div data-grm-comp="RoomCallSpeechText">
    <div class="p-2 rounded-lg select-none pointer-events-none absolute right-4 bottom-5 left-4 text-center text-sm text-white transition-all z-50 call-speech-text"
         :class="[
               (stt.show || translation.text) ? 'bottom-10 opacity-100' : 'opacity-0'
           ]"
    >
      <div>{{ stt.text }}</div>
      <div class="stt-translation-text">{{ translation.text }}</div>
    </div>

    <!--    <div class="translation-text p-2 rounded-lg select-none pointer-events-none absolute right-4 left-4 text-center text-sm text-white bg-green-800 transition-all"-->
    <!--         :class="[-->
    <!--             translation.show ? 'bottom-16 opacity-100' : 'opacity-0'-->
    <!--         ]">-->
    <!--      <span class="pr-2">{{ translation.name }}</span>-->
    <!--      <span>{{ translation.text }}</span>-->
    <!--    </div>-->
  </div>

</template>

<script>

export default {
  name: 'RoomCallSpeechText',
  components: {},
  provide() {

  },
  props: ['stt', 'translation'],
  data() {
    return {}
  },

}

</script>

<style scoped lang="scss">
.translation-text {
  background-color: rgba(6, 78, 59, 0.7);
  bottom: 100px;
}

.stt-translation-text {
  color: #4b93ff;
}

.call-speech-text{
  background-color: rgba(31, 41, 55, 0.8)
}
</style>
